export class ApiHelper {
    url: string
    urlOffine?: string = null
    offline?: boolean = null

    constructor(url: string, urlOffline: string, offline: boolean) {
        this.url = url
        this.urlOffine = urlOffline
        this.offline = offline
    }

    getApi = () => this.offline ? this.urlOffine : this.url

    getApiOnline = () => this.url
    
    getApiOffline = () => this.urlOffine
}